import {
  Extension,
  IExtension,
  IExtensionConstructorParams,
} from "../../system/setup";

export interface ICliff extends IExtension {
  purpose: Extension;
  duration: {
    id: string;
    value?: string;
    warning?: string;
  };
  end: {
    id: string;
    value?: string;
    warning?: string;
  };
}

export function initial({
  cliffDuration,
  cliffEnd,
}: IExtensionConstructorParams): ICliff {
  return {
    purpose: Extension.CLIFF,
    duration: {
      id: "cliffDuration",
      value: cliffDuration,
      warning: undefined,
    },
    end: {
      id: "cliffEnd",
      value: cliffEnd,
      warning: undefined,
    },
  };
}
